import { _ as t } from "./index980.mjs";
var e = t;
function r(a) {
  return e(this, a).get(a);
}
var m = r;
export {
  m as _
};
